// extracted by mini-css-extract-plugin
module.exports = {"sectionForm":"SectionForm_sectionForm__2AFpW","isInner":"SectionForm_isInner__2pRMp"};